/**
 * Trainova AI — English (United Kingdom / British English Locale Dictionary)
 *
 * Inherits from canonical English (en.ts) and applies standard British English
 * spellings (e.g. Organisation, Customisation, Analysing, Colour, Behaviour, Centre).
 */

import { en } from './en';

export const enGB: Record<string, string> = {
  ...en,

  // Navigation & Branding
  'nav.brand': 'Trainova AI',
  'nav.organizations': 'Organisations',
  'nav.admin_console': 'Administration Console',

  // Authentication & Login
  'auth.tenant_slug_label': 'Organisation Slug',
  'auth.org_logo_alt': 'Organisation Logo',
  'auth.org_portal_welcome': 'Welcome to the {{org}} organisation portal.',
  'auth.tenant_gateway_title': 'Tenant Gateway',
  'auth.tenant_gateway_sub_workspace': '{{tenant}} workspace',
  'auth.tenant_gateway_sub_default': 'Enterprise tenant',

  // Simulation & Briefing
  'briefing.consent_body':
    'This session will be recorded and transcribed for automated competency scoring, rubric evaluation, and trainer debriefs. Audio and video data remain securely isolated within your organisation tenant.',
  'simulation.evaluating_subtitle':
    'Analysing regulatory compliance, customer empathy, resolution effectiveness, and objection handling.',

  // Admin & Governance
  'admin.languages_subtitle':
    'Configure supported languages, default locale, and translation access for your organisation.',
  'admin.supported_languages': 'Enabled Organisation Languages',
  'users.directory_title': 'Organisation Members & User Directory',
  'tenants.title': 'Platform Organisations & Tenants',
  'breadcrumb.client_organizations': 'Client Organisations',
  'breadcrumb.org_details': 'Organisation Details',
  'table.organization': 'Organisation',
  'table.no_orgs': 'No organisations found',

  // Descriptions & Cards
  'desc.attempts_admin':
    'Monitor learner simulations across organisations, inspect attempt scorecards, and audit historical practice outcomes.',
  'desc.tenants':
    'Centralised management of enterprise client organisations, tenant provisioning, and platform governance.',
  'desc.reports':
    'Review organisation pass rates, competency benchmark bars, learner metrics, CSV/JSON data dumps.',
  'desc.udf_settings':
    'Configure learner metadata fields (region, cost centre, BU), CSV validation rules, and API sync mappings.',

  // Admin Stats & Sections
  'admin.stats.total_organizations': 'Total Client Organisations',
  'admin.stats.org_members': 'Organisation Members',
  'admin.nav_section.org_governance': 'Organisation & Access Governance',
  'admin.nav_section.customization': 'Customisation & Configuration',
  'admin.nav.org_management': 'Organisation Management',
  'admin.nav.reports_desc':
    'Review organisation pass rates, competency benchmark bars, learner metrics, CSV/JSON data dumps.',
  'admin.nav.udf_desc':
    'Configure learner metadata fields (region, cost centre, BU), CSV validation rules, and API sync mappings.',

  // Reports
  'reports.filter_organization': 'Organisation:',
  'reports.all_organizations': 'All Organisations',
  'reports.search_org_placeholder': 'Search organisation name, ID, slug...',
  'reports.all_orgs_cross_tenant': '🌐 All Organisations (Cross-Tenant)',
  'reports.no_orgs_found': 'No organisations matching search',

  // Scenarios
  'scenarios.organization_access': 'Organisation Access',
};
